export default function showInfoModal(message) {
  const wrapper = document.createElement('div');
  wrapper.innerHTML = `
    <div class="fixed inset-0 bg-gray-900/40 z-40" data-info-modal-target="overlay"></div>
    <div class="fixed inset-0 z-50 flex items-center justify-center">
      <div class="bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 rounded shadow-lg p-4 max-w-sm w-full">
        <p class="mb-4">${message}</p>
        <div class="flex justify-end">
          <button class="px-3 py-1 rounded bg-gray-200 dark:bg-gray-700">OK</button>
        </div>
      </div>
    </div>
  `;
  document.body.appendChild(wrapper);
  const remove = () => wrapper.remove();
  wrapper.querySelector('[data-info-modal-target="overlay"]').addEventListener('click', remove);
  wrapper.querySelector('button').addEventListener('click', remove);
}
